// models/Del/DelClientSignatures.js

// The data model for incoming and saving DelClientSignatures

import { v4 as uuidv4 } from "uuid";

export class DelClientSignatures {
  constructor(data = {}) {
    this.rowId = data.id || uuidv4();
    this.clientEmpName = data.client_emp_name || "";
    this.clientEmpTitle = data.client_emp_title || "";
    this.clientCompanyName = data.client_company_name || "";
    this.clientEmpSig = data.client_emp_sig
      ? "data:image/png;base64," + data.client_emp_sig
      : "";
    // Save status: 'pending' | 'saving' | 'saved' | 'error'
    // Signatures from backend are marked as 'saved', new ones are 'pending'
    this.saveStatus = data.client_emp_sig ? "saved" : "pending";
    this.saveError = null;
  }

  // Updating the client employee name
  updateClientEmpName(name) {
    this.clientEmpName = name;
  }

  // Updating the client employee title
  updateClientEmpTitle(title) {
    this.clientEmpTitle = title;
  }

  // Updating the client company name
  updateClientCompanyName(company) {
    this.clientCompanyName = company;
  }

  // Updating the client employee signature
  updateClientEmpSig(signature) {
    this.clientEmpSig = signature;
  }

  // Update save status
  setSaveStatus(status, error = null) {
    this.saveStatus = status;
    this.saveError = error;
  }

  // To json for sending to the database
  toJson() {
    // Removing the data:image/png;base64, from the signature
    const clientEmpSig = this.clientEmpSig
      .replace("data:image/png;base64,", "")
      .trim();
    return {
      id: this.rowId,
      client_emp_name: this.clientEmpName,
      client_emp_title: this.clientEmpTitle,
      client_company_name: this.clientCompanyName,
      client_emp_sig: clientEmpSig,
    };
  }

  // To patch for sending to the database
  /* @Fields = {field: values}
   */
  toPatch(action, fields) {
    const fieldMap = {
      rowId: "id",
      clientEmpName: "client_emp_name",
      clientEmpTitle: "client_emp_title",
      clientCompanyName: "client_company_name",
      clientEmpSig: "client_emp_sig",
    };
    const patch = {
      patch_type: "client_signature",
      action: action,
      id: this.rowId,
    };
    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }
    return patch;
  }
}
